import Vue from 'vue'
import { numberLingFormFunc, numberLingFormWithNumberFunc, moneyFormatFunc } from '/src/store/config'

const mixin = {
  data () {
    return {
    }
  },
  computed: {
    isSmartphone () {
      return this.$root.rootIsSmartphone
    },
    isWindows () {
      return this.$root.rootIsWindows
    },
    isIOS () {
      return this.$root.rootIsIOS
    },
    pageHasLeftBar () {
      return Boolean(this.$route.meta.leftBarComponent) && !this.isSmartphone
    }
  },
  filters: {
    money: (number) => {
      return moneyFormatFunc(number)
    }
  },
  methods: {
    numberLingForm (number, chelovek, cheloveka, chelovekov) {
      return numberLingFormFunc(number, chelovek, cheloveka, chelovekov)
    },
    numberLingFormWithNumber (number, chelovek, cheloveka, chelovekov) {
      return numberLingFormWithNumberFunc(number, chelovek, cheloveka, chelovekov)
    },
    sendSimpleEvent (data) {
      if ((window.dataLayer && window.dataLayer.push) || process.env.NODE_ENV === 'development') {
        this.$store.dispatch('gtm/sendSimpleEvent', data, { global: true })
      } else {
        this.$bus.$on('data.layer.ready', () => {
          this.$store.dispatch('gtm/sendSimpleEvent', data, { global: true })
        })
      }
    },
    moneyFormat (number) {
      return moneyFormatFunc(number)
    }
  }
}

Vue.mixin({
  mixins: [mixin]
})



// WEBPACK FOOTER //
// ./src/mixin/index.js